import { Flex } from '@radix-ui/themes'
import { Button } from '@/components/subscription/button'
import { styles } from './styles.css'
import thumbnail from './thumbnail.jpg'
import check from './check.svg'

type Props = {
  checked: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const MazzoToggle: React.FC<Props> = ({ checked, onChange }) => {
  return (
    <label htmlFor="with-mazzo" className={styles.label}>
      <Flex direction="row" align="center" justify="between" width="100%">
        <Flex direction="row" align="center" justify="center" gap="16px">
          <img src={thumbnail} className={styles.thumbnail} />
          <Flex direction="column" align="start" gap="8px">
            <p className={styles.description}>ブーケにぴったりサイズのフラワーベースを一緒にお届け！</p>
            <Flex direction="row" align="center" wrap="wrap" gap="8px">
              <span className={styles.price}>+1,980円</span>
              <Flex direction="row" align="center" gap="4px">
                <span className={styles.comparedTo}>通常価格より</span>
                <span className={styles.diff}>25%OFF</span>
              </Flex>
            </Flex>
            {checked ? (
              <Flex direction="row" align="center" justify="start" gap="4px" height="35.5px">
                <img src={check} />
                <span className={styles.mazzoIncluded}>注文に追加済み</span>
              </Flex>
            ) : (
              <Button as="button" type="button" tone="primary" size="s" fluid className={styles.button}>
                一緒に注文する
              </Button>
            )}
          </Flex>
        </Flex>
        <input type="checkbox" id="with-mazzo" checked={checked} className={styles.checkbox} onChange={onChange} />
      </Flex>
    </label>
  )
}
